import React from "react";
import { Row, Col, Modal } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import QRCode from "react-qr-code";
import data from "../../../../constants/retailPos.json";

const PaytmQRCodeModal = ({
  paytmQrCodeModalOpens,
  setPaytmQrCodeModalOpens,
  qrCodeResponse,
  handleVerifyPayment,
}) => {
  return (
    <Modal
      open={paytmQrCodeModalOpens}
      closable={false}
      okText="Verify"
      keyboard={false}
      styles={{ body: { padding: "20px 15px 15px" } }}
      onOk={handleVerifyPayment}
      onCancel={() => {
        setPaytmQrCodeModalOpens(false);
      }}
    >
      <Row>
        <Col span={7}>
          <ArrowLeftOutlined
            style={data.posScreenStyles.orderHistoryModal.backArrowIcon}
            onClick={() => {
              setPaytmQrCodeModalOpens(false);
            }}
          />
        </Col>
        <Col span={17}>
          <p style={data.posScreenStyles.parkedBillModal.parkedBillsHistoryModalTitle}>Paytm QR Code</p>
        </Col>
      </Row>
      {qrCodeResponse && qrCodeResponse.body && qrCodeResponse.body.qrData && (
        <Row
          style={{
            justifyContent: "center",
            padding: "30px 0px",
          }}
        >
          <QRCode value={qrCodeResponse.body.qrData} />
        </Row>
      )}
    </Modal>
  );
};

export default PaytmQRCodeModal;
